import type { IxcFundingV1AccountNumberKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const FUNDING_ACCOUNT_NUMBER_BASE_PATH = getResolvedPath('/funding/account-number');

export const getFundingAccountNumberPath: EntityPathBuilder<IxcFundingV1AccountNumberKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return getResolvedPath(FUNDING_ACCOUNT_NUMBER_BASE_PATH);
    case 'detail': {
      if (!context?.keys?.accountNumberId) {
        return undefined;
      }

      return getResolvedPath(`${FUNDING_ACCOUNT_NUMBER_BASE_PATH}/$accountNumberId`, context.keys);
    }
  }
};

export function getFundingAccountNumberDetailPath(accountNumberId: string | undefined) {
  if (!accountNumberId) {
    return undefined;
  }

  return getFundingAccountNumberPath({ kind: 'detail', keys: { accountNumberId } });
}
